/* Endurrad — collezioni nello stile dell'app (sections/erd-collezione.liquid, 15/10/2026).
   - Collezione moto: «È la mia moto» salva la moto nel sito (localStorage «erd_moto_sel», la stessa della barra in alto,
     con marca e modello presi dai dati del selettore) e mostra la fascia verde; se la moto scelta è questa,
     tutte le schede ricevono il bollino «Ok per la tua moto» (dicitura fissa).
   - Collezione marchio: «Trova quelli per la tua moto» accende il filtro moto oppure apre la scelta della moto. */
(function () {
  var KEY = 'erd_moto_sel';
  function leggi() { try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function pulisci(u) { return String(u || '').split('?')[0].replace(/\/$/, ''); }
  function apriScelta() {
    var b = document.querySelector('[data-erd-testata-moto]') || document.querySelector('[data-erd-sel-btn]');
    if (b) { window.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(function () { b.click(); }, 300); }
    else window.location.href = '/pages/marche-moto';
  }

  var mh = document.querySelector('[data-erd-col-moto]');
  if (mh) {
    var url = pulisci(mh.getAttribute('data-url'));
    var ok = document.querySelector('[data-erd-col-ok]');
    var btn = mh.querySelector('[data-erd-col-mia]');
    function bollini() {
      document.querySelectorAll('#ProductGridContainer .product-card__media').forEach(function (m) {
        if (m.querySelector('.erd-ric__monta')) return;
        var s = document.createElement('span'); s.className = 'erd-ric__monta'; s.textContent = '✓ Ok per la tua moto';
        m.appendChild(s);
      });
    }
    function stato() {
      var m = leggi();
      var mia = !!(m && pulisci(m.url) === url);
      if (ok) ok.hidden = !mia;
      if (btn) { btn.textContent = mia ? '✓ È la tua moto' : 'È la mia moto'; btn.classList.toggle('is-fatto', mia); btn.disabled = mia; }
      if (mia) {
        var n = ok && ok.querySelector('[data-erd-col-nome]'); if (n) n.textContent = (m.marca + ' ' + m.base).trim();
        bollini();
      }
      return mia;
    }
    if (stato()) {
      var g = document.getElementById('ProductGridContainer');
      if (g && 'MutationObserver' in window) new MutationObserver(function () { stato(); }).observe(g, { childList: true, subtree: true });
    }
    var carica = null;
    function dati() {
      if (carica) return carica;
      var base = mh.getAttribute('data-dati'), sep = base.indexOf('?') > -1 ? '&' : '?';
      function pagina(n) { return fetch(base + sep + 'page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
      carica = pagina(1).then(function (p1) {
        var rich = [];
        for (var i = 2; i <= (p1.pagine || 1); i++) rich.push(pagina(i));
        return Promise.all(rich).then(function (altre) {
          var trovata = null;
          [p1].concat(altre).forEach(function (p) { (p.voci || []).forEach(function (v) { if (!trovata && v.u && pulisci(v.u) === url && v.marca && v.base) trovata = v; }); });
          return trovata;
        });
      }).catch(function () { return null; });
      return carica;
    }
    if (btn) btn.addEventListener('click', function () {
      btn.disabled = true;
      dati().then(function (v) {
        if (!v) { btn.disabled = false; apriScelta(); return; }
        try {
          window.localStorage.setItem(KEY, JSON.stringify({ marca: String(v.marca).trim(), base: String(v.base).trim(), anno: 0, url: url }));
          window.localStorage.setItem('erd_moto_sito', '1');
        } catch (e) {}
        var t = document.querySelector('[data-erd-testata-nome]'); if (t) t.textContent = (String(v.marca).trim() + ' ' + String(v.base).trim());
        var box = document.querySelector('[data-erd-testata]'); if (box) box.classList.add('erd-testata--moto');
        stato();
        var g = document.getElementById('ProductGridContainer');
        if (g && 'MutationObserver' in window) new MutationObserver(function () { stato(); }).observe(g, { childList: true, subtree: true });
      });
    });
    var cambia = document.querySelector('[data-erd-col-cambia]');
    if (cambia) cambia.addEventListener('click', function (e) { e.preventDefault(); apriScelta(); });
  }

  var tua = document.querySelector('[data-erd-col-tua]');
  if (tua) tua.addEventListener('click', function (e) {
    var sw = document.querySelector('[data-erd-ric-compat]:not([hidden]) [data-erd-ric-sw]');
    if (sw && sw.getAttribute('aria-checked') !== 'true' && leggi()) { e.preventDefault(); sw.click(); var t = document.getElementById(tua.getAttribute('href').slice(1)); if (t) t.scrollIntoView({ behavior: 'smooth' }); return; }
    if (!leggi()) { e.preventDefault(); apriScelta(); }
  });
})();
